import React__default from 'react';
import ReactPlayer from '../node_modules/react-player/lib/index.js';
import youtube from '../node_modules/react-player/youtube.js';
import file from '../node_modules/react-player/file.js';
import { isNextJS } from '../utils.js';

const isNext = isNextJS();
const LoadPlayer = (props) => {
    try {
        if (isNext) {
            return React__default.createElement(youtube, props);
        }
        else {
            return React__default.createElement(ReactPlayer, props);
        }
    }
    catch (error) {
        return React__default.createElement(ReactPlayer, props);
    }
};
const LoadFilePlayer = (props) => {
    try {
        if (isNext) {
            const dynamic = require('next/dynamic');
            const FilePlayer = dynamic(() => import('../node_modules/react-player/file.js'), { ssr: false });
            return React__default.createElement(FilePlayer, props);
        }
        else {
            return React__default.createElement(file, props);
        }
    }
    catch (error) {
        return React__default.createElement(file, props);
    }
};
const LoadUniversalPlayer = (props) => {
    try {
        if (isNext) {
            const dynamic = require('next/dynamic');
            const Player = dynamic(() => import('../node_modules/react-player/lib/index.js'), { ssr: false });
            return React__default.createElement(Player, props);
        }
        else {
            return React__default.createElement(ReactPlayer, props);
        }
    }
    catch (error) {
        return React__default.createElement(ReactPlayer, props);
    }
};

export { LoadFilePlayer, LoadPlayer, LoadUniversalPlayer };
//# sourceMappingURL=LoadPlayer.js.map
